module.exports = __webpack_public_path__ + "static/media/20.013.cc415103.webp";